import React, { useState } from "react";
import { Tab, Tabs } from "@mui/material";
import GetKibanaDashboard from "../../components/Common/HelperComponents/KibanaDashboardComponents/GetKibanaDashboard";

// Vendor Insight Dashboard
const VendorInsight = () => {
  const [activeTab, setActiveTab] = useState("marketplace-seller-overview");

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "marketplace-seller-overview":
        return (
          <GetKibanaDashboard dashboardKey={"Marketplace Seller Overview"} />
        );
      case "agreements":
        return (
          <GetKibanaDashboard dashboardKey={"AWS Marketplace – Seller Disbursement Insights"} />
        );
      case "billed-revenue":
        return (
          <GetKibanaDashboard dashboardKey={"AWS Marketplace – Billing"} />
        );
      case "collections":
        return (
          <GetKibanaDashboard dashboardKey={"AWS Marketplace – Collection And Disbursment"} />
        );
      default:
        return null;
    }
  };

  return (
    <div style={{ marginTop: "5rem" }}>
      <Tabs value={activeTab} onChange={handleTabChange}>
        <Tab label="Marketplace Seller Overview" value="marketplace-seller-overview" />
        <Tab label="Agreements and Renewals" value="agreements" />
        <Tab label="Undisbursed" value="billed-revenue" />
        <Tab label="Disbursed" value="collections" />
      </Tabs>
      {renderTabContent()}
    </div>
  );
};

export default VendorInsight;
